
import React from 'react';
import CustomTooltip from '__common/components/CustomTooltip';
import SVG from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { getTranslation } from '_translations/translations';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { addActiveCheckbox } from '../../utils/updateProjectOption';

type Props = {
  updateProjectOption: (field: string, value: any) => void,
  value: string,
  fieldBlock: radioBlock,
  legacyPitchedRacking?: boolean,
};

export default class RadioField extends React.PureComponent<Props> {  
  tooltipButton = () => {
    return null; // Simplified - no tooltip button
  }

  unselectRadioOption = (value: any) => {
    const radio = document.querySelector(`input[value="${value}"]`);
    if (radio && radio.closest('.md-selection-control-group')) {
      const radios = radio.closest('.md-selection-control-group').children;
      Array.from(radios).forEach(el => el.classList.remove('active'));
    }
  };

  render() {
    const { fieldBlock, value, updateProjectOption, legacyPitchedRacking = false } = this.props;

    let translatedFields = [...fieldBlock.fields];
    translatedFields = translatedFields.map(field => {
      if (field.label.includes('.')) {
        field.label = getTranslation(field.label);
      }
      if (!field.checkedRadioIcon) {
        field.checkedRadioIcon = (
          <SVG src={require(`assets/media/icons/${field.icon}`)} />
        );
      }

      if (!field.uncheckedRadioIcon) {
        field.uncheckedRadioIcon = (
          <SVG src={require(`assets/media/icons/${field.icon}`)} />
        );
      }

      if (field.checkedRadioIcon) {
        delete field.icon_active;
      }

      if (field.uncheckedRadioIcon) {
        delete field.icon_inactive;
      }

      return field;
    });

    addActiveCheckbox(fieldBlock.apiField, value);
    this.unselectRadioOption(value)

    const labelContent = <FormattedMessage id={fieldBlock.label} />;
    const tooltipTitle = fieldBlock.tooltip ? fieldBlock.tooltip() : '';
    const isRowLayout = fieldBlock.id === 'railDirection' || fieldBlock.id === 'railFinish';
    const isLegacyPitchedRackingChoice = legacyPitchedRacking && isRowLayout;
    const rackingChoiceClass = fieldBlock.id === 'railFinish'
      ? 'pitched-racking-radio-field--finish'
      : 'pitched-racking-radio-field--direction';
    const emptyLegacyRadioGlyph = (
      <span className="pitched-racking-empty-radio-glyph" aria-hidden="true" />
    );

    return (
      <div
        id={`${fieldBlock.id}`}
        key={fieldBlock.label}
        className={`radio-field-container${isLegacyPitchedRackingChoice ? ` pitched-racking-radio-field ${rackingChoiceClass}` : ''}`}
      >
        {tooltipTitle ? (
          <CustomTooltip title={tooltipTitle as unknown as string} placement="top" isHtml={true}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
              <label className={`input-label ${fieldBlock.missing ? 'input-warning' : ''}`} style={{ marginBottom: 0, cursor: 'pointer' }}>
                {labelContent}
              </label>
              <InfoOutlinedIcon style={{ fontSize: '10px', color: '#6b7280' }} />
            </div>
          </CustomTooltip>
        ) : (
          <label className={`input-label ${fieldBlock.missing ? 'input-warning' : ''}`}>
            {labelContent}
          </label>
        )}
        <RadioGroup
          name={fieldBlock.label}
          id={`${fieldBlock.label}`}
          value={value}
          onChange={(event) => updateProjectOption(fieldBlock.apiField, event.target.value)}
          row={isRowLayout}
          className={isLegacyPitchedRackingChoice ? 'pitched-racking-radio-group' : undefined}
          sx={isLegacyPitchedRackingChoice ? undefined : {
            marginTop: '4px',
            ...(isRowLayout && { width: '100%', justifyContent: 'space-between' }),
            '& .MuiFormControlLabel-root': {
              marginBottom: isRowLayout ? 0 : '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              ...(isRowLayout && { marginRight: '16px' }),
            },
            '& .MuiFormControlLabel-label': {
              fontSize: '13px',
              color: '#374151',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            },
            '& .MuiRadio-root': {
  padding: '4px',
  fontSize: '18px',

  '& svg': {
    width: '18px',
    height: '18px',
  },

  '&.Mui-checked': {
    color: '#0A3C5D',
  },
},
          }}
        >
          {translatedFields.map((field) => (
            <FormControlLabel
              key={field.value}
              value={field.value}
              className={isLegacyPitchedRackingChoice
                ? `pitched-racking-option${String(field.value) === String(value) ? ' is-selected' : ''}`
                : undefined}
              control={(
                <Radio
                  icon={isLegacyPitchedRackingChoice ? emptyLegacyRadioGlyph : undefined}
                  checkedIcon={isLegacyPitchedRackingChoice ? emptyLegacyRadioGlyph : undefined}
                />
              )}
              label={
                <div
                  className="radio-option-content"
                  style={{ display: 'flex', alignItems: 'center', justifyContent:"center", gap: isLegacyPitchedRackingChoice ? '6px' : '8px' }}
                >
                  {field.checkedRadioIcon && (
                    <div
                      className="radio-option-icon"
                      style={{
                        width: isLegacyPitchedRackingChoice ? '16px' : '20px',
                        height: isLegacyPitchedRackingChoice ? '16px' : '20px',
                      }}
                    >
                      {field.checkedRadioIcon}
                    </div>
                  )}
                  {field.label}
                </div>
              }
            />
          ))}
        </RadioGroup>
      </div>
    );
  }
}
